import { Widget } from 'jamespot-front-business';

import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import styled from 'styled-components';

export const CSSWidgetTitle = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    padding-right: 0px;
`;

export const UITitle = styled.div<{ fontSize: string; fontWeight: string; textAlign: string; color: string }>`
    text-align: ${(props) => props.textAlign};
    font-size: ${(props) => props.fontSize}px;
    font-weight: ${(props) => props.fontWeight};
    color: ${(props) => props.color};
`;

export const WidgetIntranetTitle = ({
    uniqid,
    textAlign = 'left',
    fontSize = '16',
    fontWeight = 'medium',
    color,
}: {
    uniqid: string;
    textAlign: string;
    fontSize: string;
    fontWeight: string;
    color: string;
}) => {
    const widgetWrapper = useAppSelector((state) => Widget.selectors.selectWidget(state, uniqid), shallowEqual);
    return (
        <>
            {widgetWrapper && typeof widgetWrapper.title === 'string' && widgetWrapper.title.length !== 0 && (
                <CSSWidgetTitle>
                    <UITitle textAlign={textAlign} fontSize={fontSize} fontWeight={fontWeight} color={color}>
                        {widgetWrapper.title}
                    </UITitle>
                </CSSWidgetTitle>
            )}
        </>
    );
};
